import React from 'react';
import {Route, Switch} from 'react-router-dom';

import BalancesView from './BalancesView';
import ExceptionsView from './ExceptionsView';
import {INVENTORY_PATH, EXCEPTIONS_PATH} from './paths';

//Balances live at /inventory and open exceptions at /inventory/exceptions. Each opens an item's detail at
//<its path>/items/:itemId.
export function InventoryScreen() {
  return (
    <Switch>
      <Route path={EXCEPTIONS_PATH} component={ExceptionsView} />
      <Route path={INVENTORY_PATH} component={BalancesView} />
    </Switch>
  );
}
